<template>
    <header>
        <router-link to="/">
            <span>{{title}}</span>
            <UserLayout @click.native.prevent.stop class="user-layout"/>
        </router-link>
    </header>
</template>

<script>
    import LazyImage from './LazyImage';
    import UserLayout from './UserLayout';

    export default {
        name: 'PageHeader',
        components: {UserLayout, LazyImage},
        data() {
            return {
                title: null,
                defaultValue: 'File uploader',
            };
        },
        methods: {
            changedRoute(to) {
                this.title = (to.meta ? to.meta.title : null) || this.defaultValue;
            },
        },
        created() {
            this.onregister = this.$router.afterEach(this.changedRoute);
            this.changedRoute(this.$route);
        },
        destroyed() {
            this.onregister();
        }
    };
</script>

<style scoped>
    header {
        font-size: 2em;
        font-weight: bolder;
        background: #389a70;
        box-shadow: 0 0 6px #000;
        z-index: 20;
        height: 48px;
        box-sizing: border-box;
        align-items: center;
    }

    @media (max-width: 600px) {
        header {
            border-radius: 0 0 8px 8px;
        }
    }

    a {
        padding: 4px;
        color: inherit;
        text-decoration: none;
        display: flex;
        flex-direction: row;
    }

    a:active {
        background: unset;
    }

    span {
        flex: 1;
        max-width: calc(100vw - 40px);
        white-space: nowrap;
        overflow: hidden;
    }

    .user-layout {
        margin-right: 6px;
        flex: 1;
        max-width: 36px;
    }
</style>
